function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _enableMirror, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('preact'),
    h = _require.h;

var _require2 = require('@uppy/core'),
    UIPlugin = _require2.UIPlugin;

var getFileTypeExtension = require('@uppy/utils/lib/getFileTypeExtension');

var mimeTypes = require('@uppy/utils/lib/mimeTypes');

var canvasToBlob = require('@uppy/utils/lib/canvasToBlob');

var supportsMediaRecorder = require('./supportsMediaRecorder');

var CameraIcon = require('./CameraIcon');

var CameraScreen = require('./CameraScreen');

var PermissionsScreen = require('./PermissionsScreen');

var locale = require('./locale.js');
/**
 * Normalize a MIME type or file extension into a MIME type.
 *
 * @param {string} fileType - MIME type or a file extension prefixed with `.`.
 * @returns {string|undefined} The MIME type or `undefined` if the fileType is an extension and is not known.
 */


function toMimeType(fileType) {
  if (fileType[0] === '.') {
    return mimeTypes[fileType.slice(1)];
  }

  return fileType;
}
/**
 * Is this MIME type a video?
 *
 * @param {string} mimeType - MIME type.
 * @returns {boolean}
 */


function isVideoMimeType(mimeType) {
  return /^video\/[^*]+$/.test(mimeType);
}
/**
 * Is this MIME type an image?
 *
 * @param {string} mimeType - MIME type.
 * @returns {boolean}
 */


function isImageMimeType(mimeType) {
  return /^image\/[^*]+$/.test(mimeType);
}

function getMediaDevices() {
  // bug in the compatibility data
  // eslint-disable-next-line compat/compat
  return navigator.mediaDevices;
}
/**
 * Webcam
 */


module.exports = (_temp = (_enableMirror = /*#__PURE__*/_classPrivateFieldLooseKey("enableMirror"), _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Webcam, _UIPlugin);

  var _super = _createSuper(Webcam);

  // eslint-disable-next-line global-require
  // enableMirror is used to toggle mirroring, for instance when discarding the video,
  // while `opts.mirror` is used to remember the initial user setting
  function Webcam(uppy, opts) {
    var _this;

    _classCallCheck(this, Webcam);

    _this = _super.call(this, uppy, opts);
    Object.defineProperty(_assertThisInitialized(_this), _enableMirror, {
      writable: true,
      value: void 0
    });
    _this.mediaDevices = getMediaDevices();
    _this.supportsUserMedia = !!_this.mediaDevices; // eslint-disable-next-line no-restricted-globals

    _this.protocol = location.protocol.match(/https/i) ? 'https' : 'http';
    _this.id = _this.opts.id || 'Webcam';
    _this.type = 'acquirer';
    _this.capturedMediaFile = null;

    _this.icon = function () {
      return h("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, h("g", {
        fill: "none",
        fillRule: "evenodd"
      }, h("rect", {
        className: "uppy-ProviderIconBg",
        fill: "#03BFEF",
        width: "32",
        height: "32",
        rx: "16"
      }), h("path", {
        d: "M22 11c1.133 0 2 .867 2 2v7.333c0 1.134-.867 2-2 2H10c-1.133 0-2-.866-2-2V13c0-1.133.867-2 2-2h2.333l1.134-1.733C13.6 9.133 13.8 9 14 9h4c.2 0 .4.133.533.267L19.667 11H22zm-6 1.533a3.764 3.764 0 0 0-3.8 3.8c0 2.129 1.672 3.801 3.8 3.801s3.8-1.672 3.8-3.8c0-2.13-1.672-3.801-3.8-3.801zm0 6.261c-1.395 0-2.46-1.066-2.46-2.46 0-1.395 1.065-2.461 2.46-2.461s2.46 1.066 2.46 2.46c0 1.395-1.065 2.461-2.46 2.461z",
        fill: "#FFF",
        fillRule: "nonzero"
      })));
    };

    _this.defaultLocale = locale; // set default options

    var defaultOptions = {
      onBeforeSnapshot: function onBeforeSnapshot() {
        return Promise.resolve();
      },
      countdown: false,
      modes: ['video-audio', 'video-only', 'audio-only', 'picture'],
      mirror: true,
      showVideoSourceDropdown: false,
      facingMode: 'user',
      preferredImageMimeType: null,
      preferredVideoMimeType: null,
      showRecordingLength: false
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    _this.title = _this.i18n('pluginNameCamera');
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _enableMirror)[_enableMirror] = _this.opts.mirror;
    _this.install = _this.install.bind(_assertThisInitialized(_this));
    _this.setPluginState = _this.setPluginState.bind(_assertThisInitialized(_this));
    _this.render = _this.render.bind(_assertThisInitialized(_this)); // Camera controls

    _this.start = _this.start.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    _this.takeSnapshot = _this.takeSnapshot.bind(_assertThisInitialized(_this));
    _this.startRecording = _this.startRecording.bind(_assertThisInitialized(_this));
    _this.stopRecording = _this.stopRecording.bind(_assertThisInitialized(_this));
    _this.discardRecordedVideo = _this.discardRecordedVideo.bind(_assertThisInitialized(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.oneTwoThreeSmile = _this.oneTwoThreeSmile.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.changeVideoSource = _this.changeVideoSource.bind(_assertThisInitialized(_this));
    _this.webcamActive = false;

    if (_this.opts.countdown) {
      _this.opts.onBeforeSnapshot = _this.oneTwoThreeSmile;
    }

    _this.setPluginState({
      hasCamera: false,
      cameraReady: false,
      cameraError: null,
      recordingLengthSeconds: 0,
      videoSources: [],
      currentDeviceId: null
    });

    return _this;
  }

  _createClass(Webcam, [{
    key: "setOptions",
    value: function setOptions(newOpts) {
      _get(_getPrototypeOf(Webcam.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, newOpts), {}, {
        videoConstraints: _objectSpread(_objectSpread({}, this.opts.videoConstraints), newOpts == null ? void 0 : newOpts.videoConstraints)
      }));
    }
  }, {
    key: "hasCameraCheck",
    value: function hasCameraCheck() {
      if (!this.mediaDevices) {
        return Promise.resolve(false);
      }

      return this.mediaDevices.enumerateDevices().then(function (devices) {
        return devices.some(function (device) {
          return device.kind === 'videoinput';
        });
      });
    }
  }, {
    key: "isAudioOnly",
    value: function isAudioOnly() {
      return this.opts.modes.length === 1 && this.opts.modes[0] === 'audio-only';
    }
  }, {
    key: "getConstraints",
    value: function getConstraints(deviceId) {
      if (deviceId === void 0) {
        deviceId = null;
      }

      var acceptsAudio = this.opts.modes.indexOf('video-audio') !== -1 || this.opts.modes.indexOf('audio-only') !== -1;
      var acceptsVideo = !this.isAudioOnly() && (this.opts.modes.indexOf('video-audio') !== -1 || this.opts.modes.indexOf('video-only') !== -1 || this.opts.modes.indexOf('picture') !== -1);

      var videoConstraints = _objectSpread(_objectSpread({}, this.opts.videoConstraints || {
        facingMode: this.opts.facingMode
      }), deviceId ? {
        deviceId: deviceId,
        facingMode: null
      } : {});

      return {
        audio: acceptsAudio,
        video: acceptsVideo ? videoConstraints : false
      };
    } // eslint-disable-next-line consistent-return

  }, {
    key: "start",
    value: function start(options) {
      var _this2 = this;

      if (options === void 0) {
        options = null;
      }

      if (!this.supportsUserMedia) {
        return Promise.reject(new Error('Webcam access not supported'));
      }

      this.webcamActive = true;

      if (this.opts.mirror) {
        _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror] = true;
      }

      var constraints = this.getConstraints(options && options.deviceId ? options.deviceId : null);
      this.hasCameraCheck().then(function (hasCamera) {
        _this2.setPluginState({
          hasCamera: hasCamera
        }); // ask user for access to their camera


        return _this2.mediaDevices.getUserMedia(constraints).then(function (stream) {
          _this2.stream = stream;
          var currentDeviceId = null;
          var tracks = _this2.isAudioOnly() ? stream.getAudioTracks() : stream.getVideoTracks();

          if (!options || !options.deviceId) {
            currentDeviceId = tracks[0].getSettings().deviceId;
          } else {
            tracks.forEach(function (track) {
              if (track.getSettings().deviceId === options.deviceId) {
                currentDeviceId = track.getSettings().deviceId;
              }
            });
          } // Update the sources now, so we can access the names.


          _this2.updateVideoSources();

          _this2.setPluginState({
            currentDeviceId: currentDeviceId,
            cameraReady: true
          });
        }).catch(function (err) {
          _this2.setPluginState({
            cameraReady: false,
            cameraError: err
          });

          _this2.uppy.info(err.message, 'error');
        });
      });
    }
    /**
     * @returns {object}
     */

  }, {
    key: "getMediaRecorderOptions",
    value: function getMediaRecorderOptions() {
      var options = {}; // Try to use the `opts.preferredVideoMimeType` or one of the `allowedFileTypes` for the recording.
      // If the browser doesn't support it, we'll fall back to the browser default instead.
      // Safari doesn't have the `isTypeSupported` API.

      if (MediaRecorder.isTypeSupported) {
        var restrictions = this.uppy.opts.restrictions;
        var preferredVideoMimeTypes = [];

        if (this.opts.preferredVideoMimeType) {
          preferredVideoMimeTypes = [this.opts.preferredVideoMimeType];
        } else if (restrictions.allowedFileTypes) {
          preferredVideoMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isVideoMimeType);
        }

        var filterSupportedTypes = function filterSupportedTypes(candidateType) {
          return MediaRecorder.isTypeSupported(candidateType) && getFileTypeExtension(candidateType);
        };

        var acceptableMimeTypes = preferredVideoMimeTypes.filter(filterSupportedTypes);

        if (acceptableMimeTypes.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          options.mimeType = acceptableMimeTypes[0];
        }
      }

      return options;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      var _this3 = this;

      // only used if supportsMediaRecorder() returned true
      // eslint-disable-next-line compat/compat
      this.recorder = new MediaRecorder(this.stream, this.getMediaRecorderOptions());
      this.recordingChunks = [];
      var stoppingBecauseOfMaxSize = false;
      this.recorder.addEventListener('dataavailable', function (event) {
        _this3.recordingChunks.push(event.data);

        var restrictions = _this3.uppy.opts.restrictions;

        if (_this3.recordingChunks.length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
          var totalSize = _this3.recordingChunks.reduce(function (acc, chunk) {
            return acc + chunk.size;
          }, 0); // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier


          var averageChunkSize = (totalSize - _this3.recordingChunks[0].size) / (_this3.recordingChunks.length - 1);
          var expectedEndChunkSize = averageChunkSize * 3;
          var maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);

          if (totalSize > maxSize) {
            stoppingBecauseOfMaxSize = true;

            _this3.uppy.info(_this3.i18n('recordingStoppedMaxSize'), 'warning', 4000);

            _this3.stopRecording();
          }
        }
      }); // use a "time slice" of 500ms: ondataavailable will be called each 500ms
      // smaller time slices mean we can more accurately check the max file size restriction

      this.recorder.start(500);

      if (this.opts.showRecordingLength) {
        // Start the recordingLengthTimer if we are showing the recording length.
        this.recordingLengthTimer = setInterval(function () {
          var currentRecordingLength = _this3.getPluginState().recordingLengthSeconds;

          _this3.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1000);
      }

      this.setPluginState({
        isRecording: true
      });
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var _this4 = this;

      var stopped = new Promise(function (resolve) {
        _this4.recorder.addEventListener('stop', function () {
          resolve();
        });

        _this4.recorder.stop();

        if (_this4.opts.showRecordingLength) {
          // Stop the recordingLengthTimer if we are showing the recording length.
          clearInterval(_this4.recordingLengthTimer);

          _this4.setPluginState({
            recordingLengthSeconds: 0
          });
        }
      });
      return stopped.then(function () {
        _this4.setPluginState({
          isRecording: false
        });

        return _this4.getVideo();
      }).then(function (file) {
        try {
          _this4.capturedMediaFile = file; // create object url for capture result preview

          _this4.setPluginState({
            // eslint-disable-next-line compat/compat
            recordedVideo: URL.createObjectURL(file.data)
          });

          _classPrivateFieldLooseBase(_this4, _enableMirror)[_enableMirror] = false;
        } catch (err) {
          // Logging the error, exept restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this4.uppy.log(err);
          }
        }
      }).then(function () {
        _this4.recordingChunks = null;
        _this4.recorder = null;
      }, function (error) {
        _this4.recordingChunks = null;
        _this4.recorder = null;
        throw error;
      });
    }
  }, {
    key: "discardRecordedVideo",
    value: function discardRecordedVideo() {
      this.setPluginState({
        recordedVideo: null
      });

      if (this.opts.mirror) {
        _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror] = true;
      }

      this.capturedMediaFile = null;
    }
  }, {
    key: "submit",
    value: function submit() {
      try {
        if (this.capturedMediaFile) {
          this.uppy.addFile(this.capturedMediaFile);
        }
      } catch (err) {
        // Logging the error, exept restrictions, which is handled in Core
        if (!err.isRestriction) {
          this.uppy.log(err, 'error');
        }
      }
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;

        var audioTracks, videoTracks;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.stream) {
                  audioTracks = this.stream.getAudioTracks();
                  videoTracks = this.stream.getVideoTracks();
                  audioTracks.concat(videoTracks).forEach(function (track) {
                    return track.stop();
                  });
                }

                if (!this.recorder) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return new Promise(function (resolve) {
                  _this5.recorder.addEventListener('stop', resolve, {
                    once: true
                  });

                  _this5.recorder.stop();

                  if (_this5.opts.showRecordingLength) {
                    clearInterval(_this5.recordingLengthTimer);
                  }
                });

              case 4:
                this.recordingChunks = null;
                this.recorder = null;
                this.webcamActive = false;
                this.stream = null;
                this.setPluginState({
                  recordedVideo: null,
                  isRecording: false,
                  recordingLengthSeconds: 0
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "getVideoElement",
    value: function getVideoElement() {
      return this.el.querySelector('.uppy-Webcam-video');
    }
  }, {
    key: "oneTwoThreeSmile",
    value: function oneTwoThreeSmile() {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        var count = _this6.opts.countdown; // eslint-disable-next-line consistent-return

        var countDown = setInterval(function () {
          if (!_this6.webcamActive) {
            clearInterval(countDown);
            _this6.captureInProgress = false;
            return reject(new Error('Webcam is not active'));
          }

          if (count > 0) {
            _this6.uppy.info("".concat(count, "..."), 'warning', 800);

            count--;
          } else {
            clearInterval(countDown);

            _this6.uppy.info(_this6.i18n('smile'), 'success', 1500);

            setTimeout(function () {
              return resolve();
            }, 1500);
          }
        }, 1000);
      });
    }
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot() {
      var _this7 = this;

      if (this.captureInProgress) return;
      this.captureInProgress = true;
      this.opts.onBeforeSnapshot().catch(function (err) {
        var message = _typeof(err) === 'object' ? err.message : err;

        _this7.uppy.info(message, 'error', 5000);

        return Promise.reject(new Error("onBeforeSnapshot: ".concat(message)));
      }).then(function () {
        return _this7.getImage();
      }).then(function (tagFile) {
        _this7.captureInProgress = false;

        try {
          _this7.uppy.addFile(tagFile);
        } catch (err) {
          // Logging the error, except restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this7.uppy.log(err);
          }
        }
      }, function (error) {
        _this7.captureInProgress = false;
        throw error;
      });
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var _this8 = this;

      var video = this.getVideoElement();

      if (!video) {
        return Promise.reject(new Error('No video element found, likely due to the Webcam tab being closed.'));
      }

      var width = video.videoWidth;
      var height = video.videoHeight;
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      var restrictions = this.uppy.opts.restrictions;
      var preferredImageMimeTypes = [];

      if (this.opts.preferredImageMimeType) {
        preferredImageMimeTypes = [this.opts.preferredImageMimeType];
      } else if (restrictions.allowedFileTypes) {
        preferredImageMimeTypes = restrictions.allowedFileTypes.map(toMimeType).filter(isImageMimeType);
      }

      var mimeType = preferredImageMimeTypes[0] || 'image/jpeg';
      var ext = getFileTypeExtension(mimeType) || 'jpg';
      var name = "cam-".concat(Date.now(), ".").concat(ext);
      return canvasToBlob(canvas, mimeType).then(function (blob) {
        return {
          source: _this8.id,
          name: name,
          data: new Blob([blob], {
            type: mimeType
          }),
          type: mimeType
        };
      });
    }
  }, {
    key: "getVideo",
    value: function getVideo() {
      // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
      // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
      // attribute in order to determine the correct MIME type.
      var mimeType = this.recordingChunks.find(function (blob) {
        var _blob$type;

        return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
      }).type;
      var fileExtension = getFileTypeExtension(mimeType);

      if (!fileExtension) {
        return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
      }

      var name = "webcam-".concat(Date.now(), ".").concat(fileExtension);
      var blob = new Blob(this.recordingChunks, {
        type: mimeType
      });
      var file = {
        source: this.id,
        name: name,
        data: new Blob([blob], {
          type: mimeType
        }),
        type: mimeType
      };
      return Promise.resolve(file);
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this9 = this;

      if (!this.opts.countdown) return;
      setTimeout(function () {
        _this9.uppy.info(_this9.i18n('smile'), 'success', 1500);
      }, 1000);
    }
  }, {
    key: "changeVideoSource",
    value: function changeVideoSource(deviceId) {
      this.stop();
      this.start({
        deviceId: deviceId
      });
    }
  }, {
    key: "updateVideoSources",
    value: function updateVideoSources() {
      var _this10 = this;

      this.mediaDevices.enumerateDevices().then(function (devices) {
        _this10.setPluginState({
          videoSources: devices.filter(function (device) {
            return device.kind === 'videoinput';
          })
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.webcamActive) {
        this.start();
      }

      var webcamState = this.getPluginState();

      if (!webcamState.cameraReady || !webcamState.hasCamera) {
        return h(PermissionsScreen, {
          icon: CameraIcon,
          i18n: this.i18n,
          hasCamera: webcamState.hasCamera
        });
      }

      return h(CameraScreen // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, webcamState, {
        onChangeVideoSource: this.changeVideoSource,
        onSnapshot: this.takeSnapshot,
        onStartRecording: this.startRecording,
        onStopRecording: this.stopRecording,
        onDiscardRecordedVideo: this.discardRecordedVideo,
        onSubmit: this.submit,
        onFocus: this.focus,
        onStop: this.stop,
        i18n: this.i18n,
        modes: this.opts.modes,
        showRecordingLength: this.opts.showRecordingLength,
        showVideoSourceDropdown: this.opts.showVideoSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: webcamState.isRecording,
        mirror: _classPrivateFieldLooseBase(this, _enableMirror)[_enableMirror],
        src: this.stream
      }));
    }
  }, {
    key: "install",
    value: function install() {
      var _this11 = this;

      this.setPluginState({
        cameraReady: false,
        recordingLengthSeconds: 0
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }

      if (this.mediaDevices) {
        this.updateVideoSources();

        this.mediaDevices.ondevicechange = function () {
          _this11.updateVideoSources();

          if (_this11.stream) {
            var restartStream = true;

            var _this11$getPluginStat = _this11.getPluginState(),
                videoSources = _this11$getPluginStat.videoSources,
                currentDeviceId = _this11$getPluginStat.currentDeviceId;

            videoSources.forEach(function (videoSource) {
              if (currentDeviceId === videoSource.deviceId) {
                restartStream = false;
              }
            });

            if (restartStream) {
              _this11.stop();

              _this11.start();
            }
          }
        };
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.stop();
      this.unmount();
    }
  }, {
    key: "onUnmount",
    value: function onUnmount() {
      this.stop();
    }
  }]);

  return Webcam;
}(UIPlugin)), _class.VERSION = "2.1.0", _temp);